(() => {
  function initializeSlider(root) {
    if (!root || root.dataset.dfnSliderInitialized === 'true') return;

    const setup = () => {
      const track = root.querySelector('[data-dfn-related-track]');
      if (!track) return false;

      const previous = root.querySelector('[data-dfn-related-previous]');
      const next = root.querySelector('[data-dfn-related-next]');
      root.dataset.dfnSliderInitialized = 'true';

      const itemStride = () => {
        const item = track.querySelector('.grid__item');
        if (!item) return track.clientWidth;
        const styles = getComputedStyle(track);
        const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
        return item.getBoundingClientRect().width + gap;
      };

      const maxScroll = () => Math.max(0, track.scrollWidth - track.clientWidth);

      const updateButtons = () => {
        if (previous) previous.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= maxScroll() - 2;
      };

      const move = (direction) => {
        const stride = itemStride();
        const target = Math.max(0, Math.min(maxScroll(), track.scrollLeft + direction * stride));
        track.scrollTo({ left: target, behavior: 'smooth' });
      };

      previous?.addEventListener('click', () => move(-1));
      next?.addEventListener('click', () => move(1));
      track.addEventListener('scroll', updateButtons, { passive: true });

      const resizeObserver = new ResizeObserver(updateButtons);
      resizeObserver.observe(track);
      track.querySelectorAll('img').forEach((image) => {
        if (!image.complete) image.addEventListener('load', updateButtons, { once: true });
      });

      requestAnimationFrame(updateButtons);
      return true;
    };

    if (setup()) return;

    const observer = new MutationObserver(() => {
      if (setup()) observer.disconnect();
    });
    observer.observe(root, { childList: true, subtree: true });
  }

  function initializeAll(scope = document) {
    scope.querySelectorAll?.('[data-dfn-related-products]').forEach(initializeSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll());
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
